var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination display--flex",attrs:{"role":"naviagation","aria-label":_vm.$t('accessibility.pagination')}},[_c('button-with-icon',_vm._b({class:[
            'pagination__arrow__button',
            { 'disable': ! _vm.activeLeftArrow }
        ],attrs:{"icon":{
            component: function () { return import( /* webpackChunkName: 'IconArrow' */ '@/components/bundles/layout/images/icons/IconArrow' ); },
            class: ("pagination__arrow pagination__arrow--left " + (_vm.activeLeftArrow ? 'pagination__arrow--active' : ''))
        },"action":{
            execute: _vm.activeLeftArrow,
            function: function () { return _vm.navigate( 'previous' ); }
        }}},'button-with-icon',Object.assign({}, (
                _vm.activeLeftArrow
                    ? { 'aria-label': _vm.$t( 'accessibility.goTo', { page: _vm.pagination ? _vm.pagination.currentPage - 1 : 0 }) }
                    : { tabindex: -1 }
            )),false)),_c('span',{staticClass:"pagination__info"},[_vm._v(_vm._s(_vm.label))]),_c('button-with-icon',_vm._b({class:[
            'pagination__arrow__button',
            { 'disable': ! _vm.activeRightArrow }
        ],attrs:{"icon":{
            component: function () { return import( /* webpackChunkName: 'IconArrow' */ '@/components/bundles/layout/images/icons/IconArrow' ); },
            class: ("pagination__arrow pagination__arrow--right " + (_vm.activeRightArrow ? 'pagination__arrow--active' : ''))
        },"action":{
            execute: _vm.activeRightArrow,
            function: function () { return _vm.navigate(); }
        }}},'button-with-icon',Object.assign({}, (
                _vm.activeRightArrow
                    ? { 'aria-label': _vm.$t( 'accessibility.goTo', { page: _vm.pagination ? _vm.pagination.currentPage + 1 : 0 }) }
                    : { tabindex: -1 }
            )),false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }